import * as React from 'react';
import { ArticleHeading3 } from '@cian/ui-kit';
import * as styles from './BanksList.css';
import { IPromoBank } from '../../../../types/newbuilding/promos';
import { BankItem } from '../BankItem';

interface IBanksListProps {
  banks: IPromoBank[];
  onMortgageClick?(): void;
}

export function BanksList({ banks, onMortgageClick }: IBanksListProps) {
  return (
    <>
      <div className={styles['title']}>
        <ArticleHeading3>Банки</ArticleHeading3>
      </div>
      <ul className={styles['container']}>
        {banks.map(bank => (
          <li key={bank.id} className={styles['item']}>
            <BankItem bank={bank} onMortgageClick={onMortgageClick} />
          </li>
        ))}
      </ul>
    </>
  );
}
